import React from "react";
import FollowUs from '../../Components/FollowUs';
import HomeBanner from "../../Components/HomeBanner";

// --- All old 'cat' and 'p' imports are removed ---

import AllProduct from '../../Components/AllProduct';
import CategoryRow from '../../Components/CategoryRow/Index'; 
import ProductSlider from '../../Components/ProductSlider/Index'; // <-- 1. IMPORT THE RENAMED COMPONENT
import MostLovedBanner from '../../Components/MostLovedBanner/Index';
import TrustSection from '../../Components/TrustSection/Index';
import StyledByTaakagirls from '../../Components/StyledByTaakagirls/index';
import HomepageBestsellers from '../../Components/HomepageBestsellers/Index';


// --- All old 'categories' and 'products' arrays are removed ---

// --- The old 'ProductSlider' function is removed ---

const Home = () => {
    return (
        <>
            <div className="HomeBannerSection">
                <HomeBanner />
            </div>

            {/* This is your refactored CategoryRow */}
            <CategoryRow />
           
            
            <section className="bestseller-heading-section" id="bestsellers">
                <div className="bestseller-title">Bestsellers</div>
            </section>

            {/* 2. This is your new, reusable ProductSlider component.
               Since we don't pass any 'products' prop,
               it knows to automatically fetch the bestsellers. */}
            <HomepageBestsellers />

            <AllProduct />

            <MostLovedBanner />

            <StyledByTaakagirls />

            <TrustSection />

            <FollowUs />
        </>
    );
};

export default Home;